<template>
  <div class="container__speakers speakers">
    <div class="speakers__inner">
      <h2 class="speakers__title">Спикеры</h2>
      <Slider wrapper="speakers">
        <div
          class="speakers__slide"
          v-for="({ speaker, about }, index) in speakers"
          :key="index"
        >
          <h4 class="speakers__slide-title">{{ speaker }}</h4>
          <p class="speakers__slide-text">{{ about }}</p>
        </div>
      </Slider>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/temp/Slider";

export default {
  name: "Speakers",
  data: () => ({
    speakers: [
      {
        speaker: "Отец Максим",
        about:
          "Максим Горожанкин — священник, обладающий уникальным качеством говорить о вере и о Боге простым, понятным каждому языком. «После разговора с Отцом Максимом мне стало спокойно и ясно, я поняла что мне нужно дальше делать», — вспоминает Лия Сергеева о своём опыте знакомства со священником в сложнейший период своей жизни."
      },
      {
        speaker: "Отец Алексей",
        about:
          "Алексей Костин — священник, который оказал неоценимую помощь реабилитационному центру «Серафим», приехав всей семьёй в Уреки и организовав ремонт своими руками, особенным благом стало благословение часовни реабилитационного центра. Алексей Костин расскажет о своём путешествии, о православии в Грузии и о том, что это место значит лично для него."
      },
      {
        speaker: "Ольга Мамыкина",
        about:
          "Ольга Мамыкина — врач-педиатр международного уровня, системный врач-натуропат с 28-летним стажем, обучалась и работала в европейских, азиатских странах и в России. Специализируется на лечении и реабилитации детей до одного года, объединяет в своей практике тракторные и инновационные подходы в медицине. «Ольга стала первым врачом, которая поняла что происходит с Серафимом в то время, когда остальные мировые специалисты разводили руками, это стало отправной точкой в реабилитации моего сына», — поделилась Лия Сергеева."
      },
      {
        speaker: "София Сумнительная",
        about:
          "София Сумнительная — руководитель центра Монтессори, выдающийся эксперт по монтессори-педагогике с многолетней практикой. София расскажет о том, как в любых бытовых условиях организовать пространство безопасности и развития для любого ребёнка и том, как любая мама может с помощью простых доступных в доме вещей сформировать в своём ребёнке уверенность, спокойствие, самостоятельность и базовое доверие к миру. Для Лии Сергеевой, которая несколько лет назад получала дополнительное образование монтессори-педагога, София Сумнительная стала любимым педагогом и наставником, проводником бесценных знаний, а также добрым другом для семьи Сергеевых."
      },
      {
        speaker: "Тариель Лобджанидзе",
        about:
          "Тариель Лобджанидзе — блистательный врач-реабилитолог, в практике которого успешная реабилитация и полная социализация сложнейших детей. Уделяет особое внимание питанию и здоровому образу жизни. «Тариель — реабилитолог Серафима, благодаря ему Серафим находится в лучшем своём состоянии за все годы его жизни. Он поднял многих таких детей и своего ребёнка успешно социализировал, это удивительный человек и огромный специалист», — поделилась Лия Сергеева."
      },
      {
        speaker: "Мариам Сараджишвили",
        about:
          "Мариам Сараджишвили — православная писательница, автор статей о святом Серафиме Саровском и непродуманных историй людей с необычными сложными судьбами. Её книги популярны и любимы в православном сообществе, а сборники и рассказы отмечены премиями и наградами. Талантливое изложение и искренность непродуманных историй Мариам Сараджишвили находят отклик в сердцах людей. «Марьям — одна из лих первых подруг в Грузии в сложнейший период, когда я, беременная четвёртым ребёнком, с Серафимом на руках пыталась организовать строительство реабилитационного центра. Марьям — человек антикварной породы, интеллигентнейшая женщина, мама особого ребёнка», — рассказала Лия Сергеева."
      }
    ]
  }),
  components: {
    Slider
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.speakers {
  &__slider {
    &-wrap {
      width: 80%;
    }
  }

  &__slide {
    &-title {
      width: 90%;
      padding: 10px 30px;
      margin: auto;
      background-color: $sec_bg;
      text-align: center;
      border-radius: 10px;
      box-shadow: 0 1px 2px 1px rgba(#333, 0.1);
    }

    &-text {
      margin: 20px 0 0;
    }
  }
}
</style>
